import axios, { AxiosResponse } from 'axios';

const PROXY_BASE_URL = '/express-proxy/insight';

export interface INftYieldAsset {
  name: string;
  token_id: string;
  id: number;
  description: string;
  country_code: string;
}

export interface INftYieldData {
  asset: INftYieldAsset;
  expectedAnnualYield: number;
  annualYield: number;
  dailyYield: number;
  changeInDailyYield: number;
  weeklyYield: number;
  changeInWeeklyYield: number;
  monthlyYield: number;
  changeInMonthlyYield: number;
  activeShares: number;
  totalShares: number;
  activeWallets: number;
}

export interface INftYieldsResponse {
  most_yield_nfts: INftYieldData[];
}

export const fetchNftYields = (): Promise<AxiosResponse<INftYieldsResponse>> => {
  return axios.get(`${PROXY_BASE_URL}/nft-yields`);
};

/**
 * Find expectedAnnualYield for specific token_id from nft-yields data
 * Returns null if not found (like World NFT which is new)
 */
export const findExpectedAnnualYieldByTokenId = async (tokenId: string): Promise<number | null> => {
  try {
    const response = await fetchNftYields();
    const yieldData = response.data.most_yield_nfts.find((nft) => nft.asset.token_id === tokenId);

    return yieldData?.expectedAnnualYield ?? null;
  } catch (error) {
    console.warn('Failed to fetch NFT yields data:', error);
    return null;
  }
};
